import * as React from 'react'
import { useState } from 'react'

import { Content, Footer, GoToButton, Header } from './index'

import * as styles from './Layout.module.less'

export interface LayoutProps {
    content?: React.ReactNode
    footerContent?: React.ReactNode
    headerContent?: React.ReactNode
    goToBottomButton?: React.ReactNode
    goToTopButton?: React.ReactNode
    isChronologicalOrder?: boolean
    onContentBottomReached?: () => void
    onContentTopReached?: () => void
    target?: string
}

export const Layout: React.FC<LayoutProps> = (props) => {
    const isChronologicalOrder =
        props.isChronologicalOrder === undefined
            ? false
            : props.isChronologicalOrder
    const [showGoToBottomButton, setGoToBottomButtonVisibility] = useState(true)

    const onContentBottomReached = (bottomReached: boolean) => {
        setGoToBottomButtonVisibility(!bottomReached)
        bottomReached &&
            props.onContentBottomReached &&
            props.onContentBottomReached()
    }

    const [showGoToTopButton, setGoToTopButtonVisibility] = useState(false)
    const onContentTopReached = (topReached: boolean) => {
        setGoToTopButtonVisibility(!topReached)
        topReached && props.onContentTopReached && props.onContentTopReached()
    }

    const goToTopButton = !isChronologicalOrder && (
        <GoToButton
            visible={showGoToTopButton}
            to={'top'}
            content={props.goToTopButton}
        />
    )

    const goToBottomButton = (
        <GoToButton
            visible={showGoToBottomButton}
            to={'bottom'}
            content={props.goToBottomButton}
        />
    )

    return (
        <div className={styles.layout}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <Header content={props.headerContent} />
                    {goToTopButton}
                </div>
                <div className={styles.content} id={props.target}>
                    <Content
                        content={props.content}
                        onContentBottomReached={onContentBottomReached}
                        onContentTopReached={onContentTopReached}
                        targetId={props.target}
                    />
                </div>
                <div className={styles.footer}>
                    {goToBottomButton}
                    <Footer content={props.footerContent} />
                </div>
            </div>
        </div>
    )
}
